import React, {Component} from "react"

import {
	Toolbar,
	Card,
	CardText,
	FontIcon,
	TextField,
	List,
	ListItem
} from "react-md"

import axios from "axios"
import {upperCase, lowerCase} from "lodash"
import AutosizeInput from "react-input-autosize"
import Sifter from "sifter"

import "../styles/App.css"
import currencies from "../lib/currencies"


const mainCurrencies = ["USD", "EUR", "GBP", "AUD", "CAD", "KPW"]

class App extends Component
{
	constructor()
	{
		super()

		let currencyPath = upperCase(window.location.pathname.split("/")[1]), // Typed in the URL
			currency = "USD",
			country = "United States Dollar",
			countryPath = null,
			oldCountry = ""

		if (currencyPath && (countryPath = currencies.find((c) =>
			{
				return c.currency === currencyPath
			}).country))
		{
			currency = currencyPath
			country = oldCountry = countryPath
			this.setDocumentTitle(currency, country)
		}

		this.state =
			{
				currencies: currencies.filter((el) =>
				{
					return el.country !== "Bitcoin"
				}),
				currencySearch: {},
				country: country,
				countryPath: countryPath,
				currency: currency,
				oldCountry: oldCountry,
				currencyRate: 1,
				bitcoins: 1,
				converted: 0,
				currencyOptions: false,
				filterText: "",
				currenciesFiltered: mainCurrencies,
				inputSource: "btc"
			}

		let currencySearch = {}

		currencies.forEach(cur =>
		{
			currencySearch[cur.currency] = cur.country + " " + cur.currency
		})

		this.state.currencySearch = currencySearch
	}

	componentDidMount()
	{
		this.bcRate()
	}

	componentDidUpdate()
	{
	}

	setDocumentTitle = (currency = this.state.currency, country = this.state.country) =>
	{
		document.title = `Bitcoin Convert - BTC to ${country} (${currency})`
	}

	toggleCurrencyOptions = () =>
	{
		console.log("Toggle currency chooser")
		let isOpen = !this.state.currencyOptions

		if (isOpen)
		{
			this.handleFilterTextChange()
		}

		this.setState({currencyOptions: isOpen})
	}

	bcRate = (currency = this.state.currency) =>
	{
		const state = this.state

		axios.get("https://api.coindesk.com/v1/bpi/currentprice/" + currency)
			 .then((resp) =>
			 {
				 console.log("Rate:", resp.data)
				 let currencyRate = resp.data.bpi[currency].rate_float,
					 converted = currencyRate * state.bitcoins

				 this.setState({currencyRate: currencyRate, converted: converted})
			 })
	}

	handleFilterTextChange = (filterText = "") =>
	{
		let currencyList = currencies.slice(0, 6)

		if (filterText)
		{
			let sifter = new Sifter(currencies)
			currencyList = []

			let result = sifter.search(filterText,
				{
					fields: ["currency", "country"],
					sort: [
						{
							field: "currency",
							direction: "asc"
						},
						{
							field: "country",
							direction: "asc"
						}
					],
					limit: 6
				})

			result.items.forEach(res =>
			{
				currencyList.push(currencies[res.id])
			})

			console.log("Filter result", result, currencyList)

		}

		this.setState({filterText: filterText, currenciesFiltered: currencyList})
	}

	handleCurrencySelect = (country) =>
	{
		console.log("Change currency to:", currencies)

		this.setDocumentTitle(country.currency, country.country)

		this.setState({currency: country.currency, country: country.country, inputSource: "cursel"})

		this.bcRate(country.currency)
		this.toggleCurrencyOptions()
		window.history.pushState(null, null, lowerCase(country.currency))
	}

	handleUnitsChange = (ev) =>
	{
		let name = ev.target.name,
			val = ev.target.value

		if (name === "bitcoins")
		{
			this.setState({bitcoins: val, converted: val * this.state.currencyRate, inputSource: "btc"})
		}
		else
		{
			this.setState({bitcoins: val / this.state.currencyRate, converted: val, inputSource: "cur"})
		}
	}

	render()
	{
		const state = this.state

		console.log("Rendering!", state)

		return (
			<div>
				<Toolbar
					colored
					className="app-bar"
				>
					{state.countryPath
						? <h1>Bitcoin <span style={{fontWeight: "normal"}}> to </span>
							<div className="country-currency">{state.country}</div>
						</h1>
						: <h1>Bitcoin Convert</h1>}
				</Toolbar>
				<div className="convert-container">

					<Card className="convo-card">
						<CardText>
							<div className="input-holder">
								<div className="value-holder">
									<AutosizeInput
										type="number"
										className="value-input"
										name="bitcoins"
										id="bitcoins"
										value={state.inputSource === "btc"
											? parseFloat(state.bitcoins, 10)
											: parseFloat(state.bitcoins, 10).toFixed(5)}
										onChange={(e) => this.handleUnitsChange(e)}
										style={{fontSize: 32}}
									/>
								</div>
								<FontIcon style={{width: "2.2rem", height: "2.2rem", fontSize: "2.2rem", marginLeft: "10px", marginTop: "3px"}} iconClassName="fa fa-btc"/>
							</div>
						</CardText>
					</Card>

					<div className="convert-sep">
						<FontIcon
							style={{width: "3rem", height: "3rem", fontSize: "3rem"}}
							iconClassName="fa fa-exchange"
						/>
					</div>

					<Card className="convo-card">
						<CardText>
							<div className="input-holder">
								<div className="value-holder">
									<AutosizeInput
										type="number"
										className="value-input"
										name="converted"
										id="converted"
										value={state.inputSource === "cur"
											? parseFloat(state.converted, 10)
											: parseFloat(state.converted, 10).toFixed(2)}
										onChange={(e) => this.handleUnitsChange(e)}
										style={{fontSize: 32}}
									/>
								</div>
								<div className="symbol-holder" onClick={this.toggleCurrencyOptions}>
									{state.currency}
									<i className={"fa fa-chevron-" + (state.currencyOptions ? "up" : "down")} aria-hidden="true"></i>
								</div>

								{state.currencyOptions && <SelectOptions
									currencies={state.currenciesFiltered}
									filterText={state.filterText}
									handleFilterTextChange={this.handleFilterTextChange}
									handleCurrencySelect={this.handleCurrencySelect}
								/>}
							</div>
						</CardText>
					</Card>

				</div>

				<div className="credit-bit">
					Powered by <a href="https://www.coindesk.com/price/" target="coindeskwindow">CoinDesk</a>
				</div>

				{/*				<div className="under-fold">
					<h2>List of all currencies we convert from Bitcoin</h2>
					<div className="currency-list">

						{currencyList()}

					</div>

				</div>*/}
			</div>
		)
	}
}

export default App

function SelectOptions(props)
{
	console.log("SelectOptions", props)
	return (
		<div className="currency-options md-paper--1">
			<TextField
				id="filter-text"
				name="filter-text"
				placeholder="filter by country"
				rightIcon={<FontIcon>search</FontIcon>}
				className="currency-filter"
				onChange={props.handleFilterTextChange}
			/>

			<List>
				{props.currencies.map((country) =>
				{
					let ctry = currencies.find((c) => c.currency === country.currency)

					console.log("Listing " + country, ctry)

					return <ListItem primaryText={ctry.country} key={ctry.currency} onClick={() => props.handleCurrencySelect(country)}/>
				})}
			</List>

		</div>
	)
}

/*
function currencyList()
{
	return (

		currencies.map( country =>
		{
			return <a href={"/"+lowerCase(country.currency)}>{country.country+" ("+country.currency+")"}</a>
		})

	)
}*/



// WEBPACK FOOTER //
// ./src/components/App.js